module.exports = __webpack_public_path__ + "static/Tile2-Normal-footage-86c9ba640a45e2fa63199c0505b85f5a.gif";